import { Box } from '@spaceship-fspl/components';
import {
  getMetadataPropsFromPrismicSlice,
  getPageLayoutStaticProps,
  HeaderProps,
  mapNodeToHeaderProps,
  Metadata,
  MetadataProps,
  StickyHeader,
  withPageLayout,
} from 'components';
import { getAboutPage, getHeader } from 'data/prismic';
import * as React from 'react';

import { AboutHeroPanel, AboutHeroPanelProps } from './about-hero-panel';
import { CEOPanel, CEOPanelProps } from './ceo-panel';
import { HiringPanel, HiringPanelProps } from './hiring-people-panel';
import { ValuesPanel, ValuesPanelProps } from './values-panel';

interface AboutPageProps {
  headerProps?: HeaderProps;
  metadata?: MetadataProps | null;
  heroPanel: AboutHeroPanelProps;
  aboutCEOPanel: CEOPanelProps;
  valuesPanel: ValuesPanelProps;
  hiringPanel: HiringPanelProps;
}

export const getStaticProps = getPageLayoutStaticProps<AboutPageProps>(
  async () => {
    const header = await getHeader();
    const document = await getAboutPage();
    const props: AboutPageProps = {} as AboutPageProps;
    document?.map((slice) => {
      switch (slice.__typename) {
        case 'About_pageBodyMetadata': {
          props.metadata = getMetadataPropsFromPrismicSlice(slice);
          break;
        }

        case 'About_pageBodyHero': {
          props.heroPanel = {
            title: slice?.primary?.title || '',
            welcome: slice?.primary?.welcome || [],
          };
          break;
        }

        case 'About_pageBodyCeo_bio': {
          props.aboutCEOPanel = {
            title: slice?.primary?.title || '',
            tagline: slice?.primary?.tagline || '',
            profileImgURL: slice?.primary?.profile_picture?.url || '',
          };

          break;
        }

        case 'About_pageBodyValues': {
          props.valuesPanel = {
            title: slice?.primary?.title || '',
            values:
              slice?.fields?.map((value) => ({
                title: value?.title || '',
                tagline: value?.tagline || '',
                summary: value?.summary || '',
                iconURL: (value?.icon?.url as string) || '',
              })) || [],
          };
          break;
        }

        case 'About_pageBodyHiring': {
          props.hiringPanel = {
            title: slice?.primary?.title || '',
            tagline: slice?.primary?.tagline || '',
          };
          break;
        }
      }
    });

    return {
      props: {
        headerProps: mapNodeToHeaderProps(header),
        ...props,
      },
    };
  },
);

const AboutPage: React.FC<React.PropsWithChildren<AboutPageProps>> = ({
  headerProps,
  metadata,
  heroPanel,
  aboutCEOPanel,
  valuesPanel,
  hiringPanel,
}) => {
  return (
    <>
      {metadata && <Metadata {...metadata} />}
      <StickyHeader {...headerProps} buttonVariant="primary" />
      <Box paddingBottom="xxxl">
        <AboutHeroPanel {...heroPanel} />
      </Box>

      <Box
        paddingTop={{ xs: 'lg', md: 'xxl', lg: 'xxxl' }}
        paddingBottom={{ xs: 'md', md: 'none', lg: 'xxxl' }}
      >
        <CEOPanel {...aboutCEOPanel} />
      </Box>

      <ValuesPanel {...valuesPanel} />
      <HiringPanel {...hiringPanel} />
    </>
  );
};

export default withPageLayout()(AboutPage);
